<template>
    <divider-generic
    icon="person"
    style="margin-top: 24px;"
    dividerSize="medium"
    :applyBorder="false"
    :title="t('transfers.beneficiaries.edit.step2.textDivider')"/>
    <!-- Name Input -->
    <text-block-generic :params="editedNameTextBlock"/>
    <!-- Generic Destination Input -->
    <text-block-generic v-if="beneficiaryInsertedData.genericDestination" :params="editedGenericDestinationTextBlock" :mask="ACCOUNTS_NIB_IBAN"/>
    <!-- Phone Number Input -->
    <text-block-generic v-if="beneficiaryInsertedData.phoneNumber" :params="editedPhoneNumberTextBlock" :mask="PHONE_NUMBER"/>
    <!-- Email Input -->
    <text-block-generic v-if="beneficiaryInsertedData.email" :params="editedEmailTextBlock"/>
    <!-- Address Input -->
    <text-block-generic v-if="beneficiaryInsertedData.address" :params="editedAddressTextBlock"/>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Vue & Assets */
import { ref } from 'vue'
import { ACCOUNTS_NIB_IBAN, PHONE_NUMBER } from '@/assets/constants/masks'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* props received
@beneficiaryInsertedData { Object } - Object with info for our current form from an specific beneficiary
*/
const props = defineProps({
    beneficiaryInsertedData: Object
})

const editedNameTextBlock = ref({
    label: t('transfers.beneficiaries.edit.step2.nameLabel'),
    content: props.beneficiaryInsertedData.name
})

const editedGenericDestinationTextBlock = ref({
    label: t('transfers.beneficiaries.edit.step2.genericDestinationLabel'),
    content: props.beneficiaryInsertedData.genericDestination,
    mask: ACCOUNTS_NIB_IBAN
})

const editedEmailTextBlock = ref({
    label: t('transfers.beneficiaries.edit.step2.emailLabel'),
    content: props.beneficiaryInsertedData.email
})

const editedPhoneNumberTextBlock = ref({
    label: t('transfers.beneficiaries.edit.step2.phoneNumberLabel'),
    content: props.beneficiaryInsertedData.phoneNumber,
    mask: PHONE_NUMBER
})

const editedAddressTextBlock = ref({
    label: t('transfers.beneficiaries.edit.step2.addressLabel'),
    content: props.beneficiaryInsertedData.address
})
</script>
